import { Suspense, lazy } from 'react'
import { Navigate } from 'react-router-dom'

const Home = lazy(() => import('@/pages/home'))
const History = lazy(() => import('@/pages/history'))
const HistoryRecord = lazy(() => import('../pages/historyrecord'))

export default [
    {
        path: '/home',
        element: <Suspense><Home /></Suspense>
    },
    {
        path: '/history',
        element: <Suspense><History /></Suspense>
    },
    {
        path: '/historyrecord',
        element: <Suspense><HistoryRecord /></Suspense>
    },
    {
        // 重定向
        path: '/',
        element: <Navigate to={'/home'} />
    }
] as {
    path: string
    element: JSX.Element
}[]